
import { Injectable } from '@angular/core';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { FunctionGroupsDaoService } from '../function-groups-dao.service';
import { FunctionGroup } from 'src/app/_model/function-group';

// CONSTANTS
const FUNCTIONGROUPS_KEY = 'function-groups';

@Injectable()
export class FunctionGroupsStorageDaoService implements FunctionGroupsDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveFunctionGroups(functionGroups: FunctionGroup[]): Promise<void> {
    return this.keyValueStorage.store(FUNCTIONGROUPS_KEY, functionGroups);
  }
  public async getFunctionGroups(): Promise<FunctionGroup[]> {
    const stored: any[] = await this.keyValueStorage.load(FUNCTIONGROUPS_KEY) ?? [];
    // stored entries are plain JSON (no prototype/getters like displayLabel) -
    // rebuild real FunctionGroup instances from the preserved raw databag.
    return stored.map((raw) => FunctionGroup.fromDto(raw?.databag ?? raw));
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(FUNCTIONGROUPS_KEY);
  }
}
